import { createApiSlice } from "@common";
import {
  CRUD_INQUIRY_QUALIFICATION,
  GET_INQUIRY_QUALIFICATION_BY_INQUIRY_ID
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addInquiryQualification",
    method: "post",
    url: CRUD_INQUIRY_QUALIFICATION,
    stateKey: "message",
  },
  {
    name: "getInquiryQualificationByInquiryId",
    method: "get",
    url: GET_INQUIRY_QUALIFICATION_BY_INQUIRY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "inquiryQualification",
  apiConfig,
  customReducers
);
const inquiryQualificationSlice = slice;

export default inquiryQualificationSlice.reducer;

export const {
  addInquiryQualification,
  getInquiryQualificationByInquiryId,
} = thunks;

export const { rowSelect } = actions;
